/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Database",
  size: 20
}

const SvgDatabase = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <ellipse fill="none" cx={10} cy={4.64} rx={7.5} ry={3.14} />
    <path
      fill="none"
      d="M17.5 8.11c0 1.74-3.36 3.14-7.5 3.14-4.14 0-7.5-1.41-7.5-3.14M17.5 11.25c0 1.74-3.36 3.14-7.5 3.14-4.14 0-7.5-1.41-7.5-3.14"
    />
    <path
      fill="none"
      d="M17.49 4.64l.01 9.72c0 1.74-3.36 3.14-7.5 3.14-4.14 0-7.5-1.41-7.5-3.14V4.64"
    />
  </Svg>
)

SvgDatabase.defaultProps = defaultProps
export default SvgDatabase
